import React from 'react';
import ConstructionHero from '../components/construction/ConstructionHero';
import ConstructionContent from '../components/construction/ConstructionContent';
import '../stylesheets/underConstruction.css';

const UnderConstruction = () => {
  return (
    <section className="under-construction">
      <div className="under-construction__container">
        <ConstructionHero />
        <ConstructionContent />
      </div>
    </section>
  );
};

export default UnderConstruction;

